import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from '../services/master-data.service';
import { AssetsManagementService } from '../services/assets-management.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @ViewChild('myModal', { static: true, }) myModal: ElementRef;

  monthlyConfirmAssets;
  decleration;

  constructor(
    private modalService: NgbModal, private masterDataService: MasterDataService,
    private assetsManagementService: AssetsManagementService, private router: Router
  ) { }
  sweetAlertModals = []
  ngOnInit(): void {
    console.log('onInit dashboard')
    this.decleration = null;

    if (!localStorage.getItem('userid')) {
      console.log("Refresh initiated...")
      location.reload();
    };
    this.masterDataService.getPendingDecleration(localStorage.getItem('id'))
      .subscribe(res => {
        console.log("getPendingDecleration", res)
        this.decleration = res[0];
        //this.decleration={declaration:{id : 2}}
        console.log("decleration", this.decleration)
      })
    if (localStorage.getItem('isAssetConfirm')) {
      console.log("true")
    } else {
      this.monthlyAssetPopup();
    }
    // this.monthlyAssetPopup();
  }

  monthlyAssetPopup() {
    var currentDate = new Date();
    console.log("currentDate", currentDate.getDate())
    if (currentDate.getDate() == 1) {
      Swal.fire({
        text: "Please take periodic backups and sync your one drive folders.",
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {
        console.log('swal result', result);
        localStorage.setItem('isAssetConfirm', 'true');
        this.getAssetPendingRequestList();
      })
    } else if (currentDate.getDate() == 10) {
      Swal.fire({
        text: "Make sure your anti-virus is updated.",
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {
        console.log('swal result', result);
        localStorage.setItem('isAssetConfirm', 'true');
        this.getAssetPendingRequestList();

      })
    } else if (currentDate.getDate() == 15) {
      Swal.fire({
        text: "Please Tune up the QH anti-virus regularly.",
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {
        console.log('swal result', result);
        localStorage.setItem('isAssetConfirm', 'true');
        this.getAssetPendingRequestList();
      })
    } else if (currentDate.getDate() == 25) {
      Swal.fire({
        text: "Do the Windows updates regularly and make sure to restart the Laptop every day for the updates to configure properly.",
        confirmButtonColor: '#800000',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      }).then((result) => {
        console.log('swal result', result);
        localStorage.setItem('isAssetConfirm', 'true');
        this.getAssetPendingRequestList();
        // this.router.navigateByUrl('dashboard/asset-terms-of-uses');s
      })
    } else {
      console.log('inside ngoninit else');
      this.getAssetPendingRequestList();
    }
  }

  monthlyConfirmDetials;
  monthlyReason;
  showTermsOfUsesModal: boolean;
  assetIdForUses;
  whichModal: string
  getMonthlyConfirmationAssetDetails() {
    this.assetsManagementService.monthlyConfirmAssetDetails().subscribe((resp: any) => {
      console.log('monthly confirm response', resp);
      this.monthlyConfirmDetials = resp;
      if (this.monthlyConfirmDetials.length > 0) {
        var data = this.monthlyConfirmDetials[0]
        var textValue = "I confirm that I hold the custody of the " + data.userAsset.asset.subType.name + " with Sr.Number " + data.userAsset.asset.serviceTagNumber + "."
        if (data.userAsset.user.id == localStorage.getItem('id') && data.status == 'Pending') {
          console.log('inside if of monthly confirm');
          Swal.fire({
            text: textValue,
            showCancelButton: true,
            confirmButtonColor: '#800000',
            cancelButtonColor: '#FF2F2F',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Deny',
            allowOutsideClick: false,
          }).then((result) => {
            console.log('swal result', result);
            if (result.isConfirmed) {
              console.log('confirm')
              this.assetsManagementService.confirmMonthlyTransferRequest(data.userAsset.id, 'Accepted', this.monthlyReason).subscribe((resp: any) => {
                //  this.commonMessageService.swalAlertWithoutIcon('','Confirmed Successfully');
                localStorage.setItem('isAssetConfirm', 'true');
                this.whichModal = "Monthly Confirm Modal"
                this.assetIdForUses = data.userAsset.asset.id;
                this.showTermsOfUsesModal = true;
                // this.getMonthlyConfirmationAssetDetails();
              });
            } else if (result.isDismissed) {
              Swal.fire({
                text: 'Enter Reason',
                input: 'text',            
                confirmButtonColor: '#800000',
                // confirmButtonText: 'Ok',
                allowOutsideClick: false,
                preConfirm: (reason) => {
                  if(reason==''){
                    Swal.showValidationMessage(
                            'Please enter reason'
                          )
                  }else{
                    this.monthlyReason = reason;
                    console.log('reason', reason);
                      this.assetsManagementService.confirmMonthlyTransferRequest(data.userAsset.id, 'Denied', this.monthlyReason).subscribe((resp: any) => {
                        localStorage.setItem('isAssetConfirm', 'true');
                        this.getMonthlyConfirmationAssetDetails();
                  })
                  }
                }
              }).then((result) => {              
              })
            }
          })
        }
      }
    })
  }

  closedModalAssetTermsEvent(event) {
    this.showTermsOfUsesModal = false;
    console.log("event", event)
    console.log('this.decleration value after ok',this.decleration);
    if (event.whichModal == "Monthly Confirm Modal") {
      console.log('inside else of Monthly Confirm Modal');
      this.getMonthlyConfirmationAssetDetails()
    } else if (event.whichModal == "Transfer Asset Modal") {
      console.log('inside else of transfer asset modal');
      this.getAssetPendingRequestList();
    }
  }

  checkTermsOfUses:Boolean=false;
  afterSaveTermsOfUses(event){
    console.log('terms of uses value',event);
    this.checkTermsOfUses=event;
  }

  pendingTransferRequest;
  reason;
  getAssetPendingRequestList() {
    this.assetsManagementService.getHardwarePendingRequest().subscribe((resp: any) => {
      this.pendingTransferRequest = resp;
      var getNextPopup: boolean = false
      console.log('pending transfer request', this.pendingTransferRequest);
      // this.pendingTransferRequest.map((data => {
      if (this.pendingTransferRequest.length > 0) {
        // var data = this.pendingTransferRequest[0];
        this.pendingTransferRequest.map((data => {
          console.log('user id', data.toUser.id, 'login id' + localStorage.getItem('id'));
          if (data.toUser.id == localStorage.getItem('id') && data.status == 'Pending') {
            console.log('pending transfer data', data);
            console.log('user id', data.toUser.id, 'login id' + localStorage.getItem('id'));
            if (data.fromUser != null && data.fromUser.id != data.requestBy.id) {
              var textValue = "The " + data.asset.subType.name + " with Sr.Number " + data.asset.serviceTagNumber + " has been auto assigned from " + data.fromUser.firstName + " " + data.fromUser.lastName + " to you on " + data.requsetDate + ". Please give in your acceptance below."
            } else {
              var textValue = data.requestBy.firstName + " " + data.requestBy.lastName + " has transfered the " + data.asset.subType.name + " with Sr.Number " + data.asset.serviceTagNumber + " to you on " + data.requsetDate + ". Please accept/reject this transfer.";
            }
            getNextPopup = true
            Swal.fire({
              // title: 'Are you sure?',
              text: textValue,
              showCancelButton: true,
              confirmButtonColor: '#800000',
              cancelButtonColor: '#FF2F2F',
              confirmButtonText: 'Accept',
              cancelButtonText: 'Reject',
              allowOutsideClick: false,
              // willClose:()=>{},
            }).then((result) => {
              console.log('swal result', result);
              if (result.isConfirmed) {
                console.log('confirm')
                this.assetsManagementService.approveTransferRequest(data.id, 'Approved', this.reason).subscribe((resp: any) => {
                 console.log('accept response');
                  localStorage.setItem('isAssetConfirm', 'true');
                  this.whichModal = "Transfer Asset Modal"
                  this.assetIdForUses = data.asset.id;
                  this.showTermsOfUsesModal = true;
                  console.log('this.decleration value',this.decleration);
                });
              }
              else if (result.isDismissed) {

                Swal.fire({
                  text: 'Enter Reason',
                  input: 'text',            
                  allowOutsideClick: false,
                  confirmButtonColor: '#800000',
                  preConfirm: (reason) => {
                    if(reason==''){
                      Swal.showValidationMessage(
                              'Please enter reason'
                            )
                    }else{
                      console.log('swal inout value', reason);
                      this.reason = reason;
                      this.assetsManagementService.approveTransferRequest(data.id, 'Declined', this.reason).subscribe((resp: any) => {
                        // this.commonMessageService.acceptMessage();
                        localStorage.setItem('isAssetConfirm', 'true');
                        this.getAssetPendingRequestList();
                      });
                    }
                  }
                }).then((result) => {              
                })
              }
            })
          }
        }))
      }else{
        // this.showTermsOfUsesModal = true;
      }
      if (!getNextPopup) {
        console.log('inside else getnext popup');
        this.getPendingRequestListForFromUser();
      }

    });
  }

  fromUserPendingTransfer;
  getPendingRequestListForFromUser() {
    this.assetsManagementService.getFromUserPendingRequestDetails().subscribe((resp: any) => {
      this.fromUserPendingTransfer = resp
      var thirdPopup: boolean = false
      console.log('response details', resp);
      this.fromUserPendingTransfer.map((data: any) => {
        console.log('data', data);
        if (data.fromUser != null) {
          console.log('inside normal user');
          if (data.fromUser.id == localStorage.getItem('id') && data.status == 'Pending' && data.fromUser.id != data.requestBy.id) {
            var msgValue = "The " + data.asset.subType.name + " with Sr.Number " + data.asset.serviceTagNumber + " has been auto assigned from you to " + data.toUser.firstName + " " + data.toUser.lastName + " on " + data.requsetDate + ' .';
            thirdPopup = true
            Swal.fire({
              // title: 'Are you sure?',
              text: msgValue,
              // showCancelButton: true,
              confirmButtonColor: '#800000',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
              // cancelButtonText: 'Reject',
              allowOutsideClick: false,
            }).then((result) => {
              console.log('swal result', result);
              this.getMonthlyConfirmationAssetDetails()
              localStorage.setItem('isAssetConfirm', 'true');
            })
          }
        }
      })
      if (!thirdPopup) {
        this.getMonthlyConfirmationAssetDetails()
      }

    })

  }

  toggleSideNav: boolean;
  receiveToggleSideNav($event, drawer) {
    this.toggleSideNav = $event;
    drawer.toggle();
    console.log('menu sidenav this.toggleSideNav', this.toggleSideNav);
  }

  toggleDocumentSideNav: boolean;
  recieveDocumentSideNav(event, drawer) {
    this.toggleDocumentSideNav = event;
    drawer.toggle();
    console.log('document side nav this.toggleDocumentSideNav', this.toggleDocumentSideNav);
  }

  onActivate(event) {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  redirectToNgOnInit(validateIfNgOnInit: { redirect: boolean }) {
    console.log("validateIfNgOnInit", validateIfNgOnInit)
    if (validateIfNgOnInit.redirect) {
      this.ngOnInit()
    }
  }

  monthlyConfirmationAsset() {
    this.assetsManagementService.getMonthlyConfirmationPopupDetails().subscribe((resp: any) => {
      console.log('resp monthly confirmation details', resp);
      this.monthlyConfirmAssets = resp;
    });
  }
}
